import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";

export default function StepThreeForm({ onNext, onBack, allData, loading }) {
  const [formData, setFormData] = useState({
    industry: "",
    employees: "",
    office: "",
    website: "",
    fb_url: "",
    website_url: "",

  });

  useEffect(() => {
    if (allData) {
      setFormData({
        industry: allData.industry || "",
        employees: allData.employees || "",
        office: allData.office || "",
        website: allData.website || "",
        fb_url: allData.fb_url || "",
        website_url: allData.website_url || "",
      });
    }
  }, [allData]);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleNextStep = async () => {
    if (!formData.industry || !formData.employees || !formData.office || !formData.website || !formData.fb_url) {
      alert("Please complete all fields before proceeding.");
      return;
    }

    try {
      // Merge previous steps' data with current step
      const completeData = { ...allData, ...formData };

      // Send the full data to backend
      await axios.post(
        "https://6s4iavwm27icpd5skihod3nqxi0oqlwx.lambda-url.ap-southeast-1.on.aws/",
        completeData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );


      // Pass full data to next step
      onNext(completeData);
    } catch (err) {
      alert("Failed to send email. Please try again.");
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100" style={{ background: "#fff" }}>
      <div
        className="card border-0 shadow-lg"
        style={{
          maxWidth: "650px",
          width: "100%",
          borderRadius: "2rem",
          overflow: "hidden",
          background: "rgba(255,255,255,0.95)",
          backdropFilter: "blur(12px)",
          animation: "fadeIn 0.7s ease-in-out",
        }}
      >
        <h3
          className="text-center fw-bold mb-0 text-white"
          style={{ background: "#009494", padding: "2.5rem", fontSize: "1.8rem" }}
        >
          Step 3: Tell us about your business
        </h3>

        <div style={{ padding: "2.5rem" }}>
          <form>
            {/* Industry */}
            <div className="mb-4">
              <label className="form-label fw-semibold">Your business industry</label>
              <select
                value={formData.industry}
                onChange={handleChange}
                className="form-control form-control-lg"
                name="industry"
              >
                <option value="">(Select industry)</option>
                <option value="Retail / E-commerce">Retail / E-commerce</option>
                <option value="Food & Beverage">Food & Beverage</option>
                <option value="Technology / Software">Technology / Software</option>
                <option value="Education / Training">Education / Training</option>
                <option value="Health & Wellness">Health & Wellness</option>
                <option value="Real Estate">Real Estate</option>
                <option value="Professional Services">Professional Services</option>
                <option value="Nonprofit / NGO">Nonprofit / NGO</option>
                <option value="Other">Other</option>
              </select>
            </div>

            {/* Employees */}
            <div className="mb-4">
              <label className="form-label fw-semibold">Number of employees</label>
              <select
                value={formData.employees}
                onChange={handleChange}
                className="form-control form-control-lg"
                name="employees"
              >
                <option value="">(Select one)</option>
                <option value="1 (Just me)">1 (Just me)</option>
                <option value="2–10">2–10</option>
                <option value="11–50">11–50</option>
                <option value="51–200">51–200</option>
                <option value="201+">201+</option>
              </select>
            </div>

            {/* Office */}
            <div className="mb-4">
              <label className="form-label fw-semibold">Do you have an office?</label>
              <select
                value={formData.office}
                onChange={handleChange}
                className="form-control form-control-lg"
                name="office"
              >
                <option value="">(Select your setup)</option>
                <option value="Yes, physical office">Yes, physical office</option>
                <option value="Remote team only">Remote team only</option>
                <option value="Both office and remote setup">Both office and remote setup</option>
                <option value="Not yet established">Not yet established</option>
              </select>
            </div>

            {/* Website */}
            <div className="mb-4">
              <label className="form-label fw-semibold">Do you already have a website?</label>
              <select
                value={formData.website}
                onChange={handleChange}
                className="form-control form-control-lg"
                name="website"
              >
                <option value="">(Select one)</option>
                <option value="Yes, and it’s active">Yes, and it’s active</option>
                <option value="Yes, but it needs improvement">Yes, but it needs improvement</option>
                <option value="No, we don’t have one yet">No, we don’t have one yet</option>
                <option value="We had one before but it’s offline now">We had one before but it’s offline now</option>
              </select>
            </div>

            {/* Website URL — shown only if answer contains "Yes" */}
            {formData.website.includes("Yes") && (
              <div className="form-floating mb-4">
                <input
                  type="text"
                  name="website_url"
                  id="website_url"
                  className="form-control"
                  placeholder="Website URL"
                  value={formData.website_url}
                  onChange={handleChange}
                  required
                />
                <label htmlFor="website_url">Website URL</label>
              </div>
            )}


            <div className="form-floating mb-5">
              <input
                type="text"
                name="fb_url"
                className="form-control"
                placeholder="Facebook URL"
                value={formData.fb_url}
                onChange={handleChange}
              />
              <label>Facebook URL</label>
            </div>

            {/* Buttons */}
            <div className="d-flex gap-3">
              <button
                type="button"
                onClick={onBack}
                className="btn w-100 py-3 fw-semibold"
                style={{ background: "#e2e2e2", color: "#3b3b3b", borderRadius: "0.7rem" }}
              >
                ← Back
              </button>

              <button
                type="button"
                onClick={handleNextStep}
                disabled={loading}
                className="btn w-100 py-3 fw-semibold"
                style={{ background: "#009494", color: "white", borderRadius: "0.7rem", opacity: loading ? 0.7 : 1 }}
              >
                {loading ? "Sending..." : "Next →"}
              </button>
            </div>
          </form>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(15px); }
          to { opacity: 1; transform: translateY(0); }
        }
            /* Make Step 2 input text bigger */
  .form-control {
    font-size: 1.5rem !important;
  }
      `}</style>
    </div>
  );
}
